import EventProjectsAndUsersReset from "./reset";

export default class EventProjectsAndUsersResetV3 extends EventProjectsAndUsersReset {

    constructor(sessionEvent: any) {
        super(sessionEvent);

        // convert to standard json
        this.data.projectUsers = _.map(this.data.projectUsers, (record:any[])=>{
            return {
                'userId'        : record[0],
                'projectId'     : record[1],
                'projectRole'   : record[2],
                'access'        : record[3],
                'inheritance'   : record[4],
                'watchAll'      : !!record[5],
                'id'            : record[6],
                'teamId'        : record[7],
            }
        })
    }

};
